import { render } from "./Avatar.vue?vue&type=template&id=22877b1c"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22877b1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22877b1c', __exports__)) {
    api.reload('22877b1c', __exports__)
  }
  
  module.hot.accept("./Avatar.vue?vue&type=template&id=22877b1c", () => {
    api.rerender('22877b1c', render)
  })

}


export default __exports__